import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, PartyPopperIcon, TriangleAlertIcon } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { HotmartSalesFunnel } from '../components/HotmartSalesFunnel';
import { Footer } from '../components/Footer';
const includes = ['Qué hacer durante el proceso, día por día', 'Cómo organizar tus días sin improvisar', 'Hidratación, nutrientes y hábitos de apoyo'];
export function Upsell() {
  return <div className="w-full bg-cream font-sans text-charcoal" data-id="element-240" data-mp="2ixlnd044aoed">
      {/* Alert bar */}
      <div className="w-full bg-coral py-2.5" data-id="element-241" data-mp="2izfzpq1bp86u">
        <p className="mx-auto flex max-w-3xl items-center justify-center gap-2 px-5 text-center text-[13px] font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-242" data-mp="247nysj29zwon">
          <TriangleAlertIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-243" data-mp="2wxmrcofoiby2" />
          ¡Espera! Antes de terminar, quiero decirte algo importante.
        </p>
      </div>

      <main data-id="element-244" data-mp="31q64xled972v">
        <section className="relative w-full overflow-hidden" data-id="element-245" data-mp="17tgen0jr6i5c">
          <div className="leaf-watermark pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-246" data-mp="17tyiai8qvyna" />

          <div className="relative mx-auto grid max-w-6xl items-center gap-10 px-5 py-12 sm:px-6 lg:grid-cols-[55%_45%] lg:py-16" data-id="element-247" data-mp="12vx348efwjh3">
            {/* Cover */}
            <motion.div initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            ease: [0.23, 1, 0.32, 1],
            delay: 0.08
          }} className="order-1 flex justify-center lg:order-2" data-id="element-248" data-mp="1cs01r4a31zza">
              <motion.img src="https://cdn.magicpatterns.com/uploads/j2h27bwkcaLB67RGJoCF9a/Portada_UpSell_-_Reinicio_Metabolico.png" alt="Portada de la guía Reinicio Metabólico: Drenaje y Absorción" className="w-full max-w-[380px] rounded-2xl shadow-[0_24px_60px_rgba(26,60,46,0.3)] ring-1 ring-gold/30" animate={{
              y: [0, -12, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} width={1250} height={1250} data-id="element-249" data-mp="20i43f63pnpnn" />
            </motion.div>

            {/* Copy */}
            <motion.div initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            ease: [0.23, 1, 0.32, 1]
          }} className="order-2 lg:order-1" data-id="element-250" data-mp="zu3o4uzm7ait">
              <p className="flex items-center gap-2 text-[15px] font-semibold text-forest" data-id="element-251" data-mp="19r88qqdtaxxi">
                <PartyPopperIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-252" data-mp="1dsadfmqi026v" />
                ¡Felicidades por adquirir el Método de Vaciado!
              </p>

              <h1 className="mt-4 text-[30px] font-bold leading-[1.08] tracking-tight text-charcoal sm:text-[42px]" data-id="element-253" data-mp="1njxz170dip0f">
                Ya tienes tu método. Esto es lo que hace que el proceso sea más fácil.
              </h1>

              <div className="mt-5 space-y-4 text-base font-normal leading-relaxed text-warmgray" data-id="element-254" data-mp="1xingwzs9s9go">
                <p data-id="element-255" data-mp="3i0o7cx1c5e8z">
                  Cuando haces cambios importantes en tu alimentación y rutina, tu cuerpo necesita
                  hidratación, nutrientes y buenos hábitos para funcionar correctamente.
                </p>
                <p data-id="element-256" data-mp="381p9m9i3z30r">
                  Por eso creamos el{' '}
                  <strong className="font-semibold text-forest" data-id="element-257" data-mp="3335jry0e9734">Reinicio Metabólico</strong>: una
                  guía práctica que te muestra qué hacer durante el proceso, cómo organizar tus días
                  y cómo apoyar a tu cuerpo paso a paso.
                </p>
              </div>

              <ul className="mt-6 space-y-2.5" data-id="element-258" data-mp="3qzjecbc7esdc">
                {includes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-charcoal" data-id="element-259" data-mp="3m1rm1g7nd48m">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-260" data-mp="nbrleekhqu1m" />
                    {item}
                  </li>)}
              </ul>

              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="mt-7 inline-flex flex-col rounded-2xl bg-forest px-6 py-5 shadow-lg" data-id="element-261" data-mp="32rpt7menbw5">
                <span className="text-[13px] font-semibold uppercase tracking-widest text-gold" data-id="element-262" data-mp="3uavsg4n686om">
                  Agrégalo hoy por solo
                </span>

                <span className="mt-2 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-263" data-mp="qr16xw8obbgy">
                  <span className="text-[40px] font-bold leading-none tracking-tight text-white" data-id="element-264" data-mp="c3y9fpkcp2tm">
                    $17 USD
                  </span>
                  <span className="text-lg font-semibold leading-none text-white/50 line-through" data-id="element-265" data-mp="h06gsgsb3rq8">
                    $47 USD
                  </span>
                </span>

                <span className="mt-3 inline-flex w-fit rounded-full bg-coral px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-266" data-mp="19k525m1jhwdo">
                  Ahorras $30 — 64% de descuento
                </span>

                <span className="mt-2 text-[12px] text-white/60" data-id="element-267" data-mp="2p7s6y8lqw8ei">
                  Precio regular $47 USD · solo disponible en esta página
                </span>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* Decision */}
        <section className="w-full bg-mint py-14" data-id="element-268" data-mp="2bawkneghgkgi">
          <div className="mx-auto max-w-2xl px-5 text-center sm:px-6" data-id="element-269" data-mp="26b0h1gbp6v1h">
            <Reveal data-id="element-270" data-mp="26d4scjbxewbs">
              <p className="text-lg font-semibold leading-relaxed text-forest" data-id="element-271" data-mp="2katcfoy65zfs">
                Así no tienes que buscar información por separado ni preguntarte:
                <span className="mt-1 block italic text-charcoal" data-id="element-272" data-mp="2g7n0q1safg1x">“¿Y ahora qué hago?”</span>
              </p>
              <p className="mt-3 text-base text-warmgray" data-id="element-273" data-mp="3vo5cdoqt5xwo">
                Tienes todo organizado en un solo lugar.
              </p>
            </Reveal>

            <Reveal delay={0.08} className="mt-8" data-id="element-274" data-mp="2oe8ttybsjn6b">
              <HotmartSalesFunnel data-id="element-275" data-mp="2ofjye0d28yyh" />
            </Reveal>

            <Reveal delay={0.12} data-id="element-276" data-mp="2tbhgoc7vwfdw">
              <p className="mt-6 text-xs leading-relaxed text-warmgray" data-id="element-277" data-mp="2ten4zp8ovd8k">
                Se cobra en un solo pago con los datos que ya usaste. Tu compra del Método de
                Vaciado Biológico está confirmada, elijas lo que elijas.
              </p>
            </Reveal>
          </div>
        </section>
      </main>

      <Footer data-id="element-278" data-mp="2am2gek00vuak" />
    </div>;
}